enum ComoTransactionIdSource {
  ClientID = 'client-id',
  OrderID = 'order-id',
  SequenceID = 'sequence-id',
}

export { ComoTransactionIdSource };
